/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * qualiq-backend API
 * OpenAPI spec version: 1.0.0
 */

export type NotificationType =
  (typeof NotificationType)[keyof typeof NotificationType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NotificationType = {
  TASK_ASSIGNED: "TASK_ASSIGNED",
  TASK_STATUS_CHANGED: "TASK_STATUS_CHANGED",
  ACTION_POINT_ASSIGNED: "ACTION_POINT_ASSIGNED",
  ACTION_POINT_STATUS_CHANGED: "ACTION_POINT_STATUS_CHANGED",
  CHECKPOINT_STATUS_CHANGED: "CHECKPOINT_STATUS_CHANGED",
  FEEDBACK_STATUS_CHANGED: "FEEDBACK_STATUS_CHANGED",
  FEEDBACK_NEEDS_INFO: "FEEDBACK_NEEDS_INFO",
  FEEDBACK_RESOLVED: "FEEDBACK_RESOLVED",
  FEEDBACK_REJECTED: "FEEDBACK_REJECTED",
  FEEDBACK_REPLY: "FEEDBACK_REPLY",
  TASK_CREATED: "TASK_CREATED",
  ACTION_POINT_CREATED: "ACTION_POINT_CREATED",
  PHASE_CREATED: "PHASE_CREATED",
} as const;
